import React from 'react';
import ContentLoader from 'react-content-loader';

const ShimmerLoader = (props) => (
  <ContentLoader
    speed={2}
    width={390}
    height={800}
    viewBox="0 0 390 800"
    backgroundColor="#162143"
    foregroundColor="#1c2b5a"
    {...props}
  >
    {/* Header: Save up to 30% */}
    <rect x="20" y="20" rx="4" ry="4" width="200" height="20" />
    <rect x="20" y="50" rx="3" ry="3" width="280" height="16" />

    {/* Big Banner */}
    <rect x="20" y="90" rx="12" ry="12" width="350" height="160" />

    {/* Dots under carousel */}
    <rect x="150" y="260" rx="4" ry="4" width="90" height="8" />

    {/* Top Brands Title */}
    <rect x="20" y="290" rx="4" ry="4" width="100" height="20" />
    <rect x="20" y="320" rx="3" ry="3" width="60" height="16" />

    {/* Brand Icons Row */}
    <circle cx="50" cy="370" r="30" />
    <rect x="30" y="410" rx="3" ry="3" width="40" height="12" />

    <circle cx="120" cy="370" r="30" />
    <rect x="100" y="410" rx="3" ry="3" width="40" height="12" />

    <circle cx="190" cy="370" r="30" />
    <rect x="170" y="410" rx="3" ry="3" width="40" height="12" />

    <circle cx="260" cy="370" r="30" />
    <rect x="240" y="410" rx="3" ry="3" width="40" height="12" />

    <circle cx="330" cy="370" r="30" />
    <rect x="310" y="410" rx="3" ry="3" width="40" height="12" />
  </ContentLoader>
);

export default ShimmerLoader;
